// extracted by mini-css-extract-plugin
export var cardWrapper = "_5y-0";